<template>
  <div>
    <div class="createPlayStep" v-if="opendataAnalysis == 1">
      <div class="headReturn">
        <span @click="toSetting"> <i class="el-icon-arrow-left"></i> 返回列表</span>
        <span style="margin: 0 20px">|</span>
        <span class="name">新人优惠券管理</span>
      </div>

      <input-form
        ref="inputForm"
        style="margin-top: 20px"
        :inputData="inputData"
        :pageName="pageName1"
        :btnPosition1="true"
        @toParentVal="querysearchContent"
      ></input-form>

      <div class="section-right-content-box-table" style="margin: 20px">
        <div class="table-box">
          <el-table
            ref="multipleTable"
            :data="recordData"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; opacity: 1"
            @selection-change="handleSelectionChange"
            v-loading="loading"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column label="活动名称">
              <template slot-scope="scope">
                <div class="activityName">
                  <el-popover placement="top-start" width="500" trigger="hover">
                    <p style="margin: 20px">
                      请用手机京东扫描下面二维码查看您店铺的活动详情
                    </p>

                    <!-- <div class="qrcode" :id="'qrcode' + scope.row.id" :ref="'qrcode' + scope.row.id" style="margin-left: 80px"></div> -->
                    <qrcode-vue
                      class="qrcode"
                      :id="'qrcode' + scope.row.id"
                      :ref="'qrcode' + scope.row.id"
                      :size="qrcodeVue.size"
                      :value="scope.row.idUrl"
                      :logo="qrcodeVue.logo"
                      :bgColor="qrcodeVue.bgColor"
                      :fgColor="qrcodeVue.fgColor"
                      style="margin-left: 80px"
                    ></qrcode-vue>
                    <div>
                      <p style="margin: 20px">
                        链接地址：(手机京东店铺中活动详情链接地址)
                      </p>
                      <el-input readonly v-model="scope.row.idUrl" style="margin: 0 20px; width: 220px"></el-input
                      ><el-button type="primary" v-clipboard:copy="scope.row.idUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"
                        >复制</el-button
                      >
                      <el-button type="primary" @click="handleSrcImg(scope.row.id)">下载</el-button>
                    </div>
                    <img src="../../../assets/images/integralCenter/list_code.svg" alt="活动二维码" class="code" slot="reference" />
                  </el-popover>
                  <span>{{ scope.row.activityName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="活动类型" width="100px;">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 11">新人优惠券</span>
              </template>
            </el-table-column>
            <el-table-column label="活动时间" width="180px;">
              <template slot-scope="scope">
                起:<span>{{ scope.row.activityStartTime }}</span> 止:<span>{{ scope.row.activityEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="allowLevelName" label="会员等级"></el-table-column>
            <el-table-column label="优惠信息" width="200px;">
              <template slot-scope="scope">
                <span>{{ scope.row.discount }}</span
                >.00元/满 <span>{{ scope.row.quota }}</span
                >.00元
              </template>
            </el-table-column>
            <el-table-column label="优惠券有效期" width="180px;">
              <template slot-scope="scope">
                起:<span>{{ scope.row.couponStartTime }}</span> 止:<span>{{ scope.row.couponEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="优惠券类型" width="180px;">
              <template slot-scope="scope">
                <span v-if="scope.row.couponType == 1">内部优惠券</span>
                <span v-if="scope.row.couponType == 2">外部优惠券</span>
              </template>
            </el-table-column>
            <el-table-column label="剩余量">
              <template slot-scope="scope">
                <span v-if="scope.row.couponType == 1">{{ scope.row.numOfLeft }}</span>
                <span v-if="scope.row.couponType == 2">-</span>
              </template>
            </el-table-column>
            <el-table-column label="活动状态" width="180px">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">
                  <div class="auditSuccessful_ok1"></div>
                  <div style="float: left; margin-left: 20px" class="auditSuccessful_title">
                    未开始
                  </div></span
                >
                <span v-if="scope.row.status == 2">
                  <div class="auditSuccessful_ok2"></div>
                  <div style="float: left; margin-left: 20px" class="auditSuccessful_title">
                    进行中
                  </div></span
                >
                <span v-if="scope.row.status == 3">
                  <div class="auditSuccessful_ok3"></div>
                  <div style="float: left; margin-left: 20px" class="auditSuccessful_title">
                    已结束
                  </div></span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <span
                  class="statistics"
                  style="cursor: pointer"
                  @click="opendataAnalysisContent(scope.row.id)"
                  v-zoom="{ from: pageName1, name: '数据统计' }"
                  >数据统计</span
                >
                <span
                  style="cursor: pointer"
                  v-if="scope.row.status == 1 || scope.row.status == 2"
                  class="closestatistics"
                  v-zoom="{ from: pageName, name: '关闭' }"
                  @click="closestatistics(scope.row.id)"
                  >关闭</span
                >
                <span v-show="scope.row.status == 3" style="margin: 0 20px 0 10px">-</span>
                <span
                  style="cursor: pointer"
                  class="closestatistics"
                  v-zoom="{ from: pageName, name: '删除' }"
                  @click="deletestatistics(scope.row.id)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            style="text-align: right; margin: 40px 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="recordParams.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordTotal"
            :current-page="recordParams.current"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <dataAnalysis v-if="opendataAnalysis == 2" :pageName="pageName1 + '数据统计'" @returnBack="returnBackChange" :ids="ids"></dataAnalysis>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "../../../components/inputForm";
import { queryPage, closeBenefitActivity, deleteBenefitActivity } from "@/api/integralCenter/benefitActivityController";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
import dataAnalysis from "./data-analysis";
import qrcodeVue from "qrcode-vue";
export default {
  components: {
    inputForm,
    dataAnalysis,
    qrcodeVue,
  },
  props: ["pageName"],
  created() {},
  data() {
    return {
      qrcodeVue: {
        size: 260,
        bgColor: "#fff",
        fgColor: "#000",
        value: "https://www.baidu.com/", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      pageName1: this.pageName,
      recordParams: {
        //优惠券表格下方
        current: 1,
        size: 10,
        type: 11,
        activityName: "",
        startTime: "",
        endTime: "",
        status: "",
      },
      opendataAnalysis: 1,
      username: "",
      startTime: "",
      endTime: "",
      status: "",
      recordData: [],
      typeType: 11,
      id: "",
      ids: "",
      status: "",
      loading: true,
      queryDTO: {},
      recordTotal: 0,
      inputData: [
        {
          name: "活动主题:",
          val: "username",
          placeholder: "请输入活动主题",
        },
        {
          name: "活动时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
    };
  },
  mounted() {
    this.prefixQue();
    this.$refs.inputForm.formSearch();
    // this.queryPayRecord();
  },

  methods: {
    handleSrcImg(id) {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode${id} img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "huodongyulan";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
        })
        .catch((res) => {});
    },
    //获取新人优惠券活动
    queryPayRecord() {
      this.loading = true;
      this.recordData.forEach((item, index) => {
        var ref = "qrcode" + item.id;
        this.$refs[ref].innerHTML = "";
      });
      queryPage(this.recordParams)
        .then((res) => {
          // console.log(res, "res");
          this.recordData = res.data.records;
          this.recordData.forEach((item) => {
            // item.idUrl = this.activityUrl + "/discount_coupon?index=1" + "&id=" + item.id + "&venderId=" + this.venderId;

            let xcxUrl = this.$commonUrl();
            let options = {
              activityId: item.id,
              venderId: this.venderId,
              activityType: item.activityType || item.type,
              index: 1,
              id: item.id,
            };
            let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A${options.id}%2C%22index%22%3A${options.index}%7D`;
            item.idUrl = xcxUrl + "pages/integralStore/discountCoupon/discountCoupon.html%3fitem%3d" + params1;
            // this.$nextTick(() => {
            //   let queryId = "qrcode" + item.id;
            //   this.qrcodeAll(item.idUrl, queryId);
            // });
          });
          this.recordTotal = Number(res.data.total);
          this.loading = false;
        })
        .catch((res) => {});
    },
    opendataAnalysisContent(id) {
      this.opendataAnalysis = 2;
      this.ids = id;
    },
    returnBackChange() {
      this.opendataAnalysis = 1;
    },
    //查询
    querysearchContent(from) {
      console.log(from.username);
      console.log(from.startTime);
      this.recordParams.current = 1;
      this.recordParams.activityName = from.username;
      this.recordParams.startTime = from.startTime;
      this.recordParams.endTime = from.endTime;
      this.recordParams.status = from.status;
      this.queryPayRecord();
    },
    //重置
    resetContent() {
      this.recordParams = {
        current: 1,
        size: 10,
        type: 11,
        activityName: "",
        startTime: "",
        endTime: "",
        status: "",
      };
      this.inputData = {
        username: "",
        startTime: "",
        endTime: "",
        status: "",
      };
      this.queryPayRecord();
    },
    //关闭新人优惠券活动
    closestatistics(a) {
      this.id = a;
      closeBenefitActivity({ id: this.id })
        .then((res) => {
          if (res && res.code == 1) {
            this.queryPayRecord();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    //关闭删除
    deletestatistics(a) {
      this.id = a;
      deleteBenefitActivity({ id: this.id })
        .then((res) => {
          if (res && res.code == 1) {
            this.queryPayRecord();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    handleSelectionChange() {},
    handleCurrentChange(val) {
      this.recordParams.current = val;
      this.queryPayRecord();
    },
    handleSizeChange(val) {
      this.recordParams.size = val;
      this.queryPayRecord();
    },
    toSetting() {
      // let routeUrl = this.$router.resolve({
      //   path: "/integralCenter/integralCenter/memberPower",
      // });
      // window.open(routeUrl.href);
      this.$emit("returnBack");
    },
  },
};
</script>

<style scoped lang="scss">
.createPlayStep {
  min-width: 1000px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #2e3458;
      font-size: 16px;
      // font-family: PingFang SC;
      font-weight: bold;
      line-height: 22px;
      cursor: default;
    }
  }
}
.section-right-content-box-table {
  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-right: 4px;
      cursor: pointer;
    }
  }
  .auditSuccessful_ok1 {
    // min-width: 950px;
    position: absolute;
    top: 45%;
    left: 15px;
    line-height: 50%;
    width: 6px;
    height: 6px;
    background: #cccccc;
    border-radius: 50%;
    opacity: 1;
  }
  .auditSuccessful_ok2 {
    position: absolute;
    top: 45%;
    left: 15px;
    line-height: 50%;
    width: 6px;
    height: 6px;
    background: #ffb95e;
    border-radius: 50%;
    opacity: 1;
  }
  .auditSuccessful_ok3 {
    position: absolute;
    top: 45%;
    left: 15px;
    line-height: 50%;
    width: 6px;
    height: 6px;
    background: #fe4d45;
    border-radius: 50%;
    opacity: 1;
  }
  .auditSuccessful_title {
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    opacity: 1;
  }
  .statistics {
    // float: left;
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    margin-right: 10px;
    opacity: 1;
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  .closestatistics {
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    // color: #7f85e9;
    margin-right: 10px;
    opacity: 1;
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
}
</style>
